// extracted by mini-css-extract-plugin
module.exports = {"title":"DocFileLink_title__mbcrw","fileInfo":"DocFileLink_fileInfo__3mF4O","text":"DocFileLink_text__3q4dH"};